import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Link from 'components/common/Link/Link'

const Brand = ({ className, brandLogo, brandName, brandUrl }) =>
  <Wrapper className={ className } to={ brandUrl } data-at-globalsearch-brand>
    <Image src={ `${brandLogo}?$BOT-GlobalSearch-Brand-Desktop-h30$` } alt={ brandName } />
  </Wrapper>

Brand.propTypes = {
  brandLogo: PropTypes.string,
  brandName: PropTypes.string,
  brandUrl: PropTypes.string,
  className: PropTypes.string
}

export default Brand

const Image = styled.img`
  display: inline-block;
  max-width: 100%;
  max-height: 30px;
  vertical-align: middle;
`

const Wrapper = styled(Link)`
  display: inline-block;
  padding: 0 12px;
  text-align: center;
  border: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('height', '81px', '77px')}
  ${Mixin.responsive('width', '144px', '136px')}
  ${Mixin.middle()}
`
